import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

import Button from '@/src/shared/ui/button'
import {Link} from '@/src/shared/ui/link'

export const ProductAbsolutable = styled.div`
  background: white;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition-property: unset;
  border-radius: 28px;

  & > * {
    display: none;
  }

  @media ${media.lg} {
    position: relative;

    margin: 17px 0;
    margin-bottom: unset;
    width: 100%;
  }
`

// export const ProductPropertyWrap = styled.div<{$type: ProductProperty['type']}>`
//   margin-bottom: 10px;
//   display: flex;
//   gap: 4px;
//
//   ${props =>
//     props.$type === 'list' &&
//     css`
//       flex-direction: column;
//     `}
// `

export const ProductPropertyName = styled.div`
  font-weight: 300;
  line-height: 1.2;

  &::after {
    content: ': ';
  }
`

export const ProductPropertyValueItem = styled(Button)`
  min-width: 30px;
  min-height: unset;

  padding: 5px;
`

export const ProductPropertyValue = styled.div`
  font-weight: 300;
  line-height: 1.2;

  display: inline-flex;
  flex-wrap: wrap;

  gap: 8px;
  padding-top: 8px;
`

export const ProductProperties = styled.div`
  display: flex;
  flex-flow: column;
`
export const ProductPropertyContainer = styled.div``

export const ProductImage = styled.div`
  margin: 21px 0;
  margin-top: unset;
  height: 150px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;

  & img[data-back] {
    display: none;
  }

  & img {
    width: auto;
    height: auto;

    max-width: 100%;
    max-height: 100%;

    object-fit: cover;
  }

  @media ${media.md} {
    height: 210px;
  }
`

export const SaleInfo = styled.span<{$iconSrc: string}>`
  z-index: 10;

  position: absolute;

  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;

  top: 26px;
  left: 26px;

  padding: 6px 3px;
  background: ${theme.colors.primary};
  font-size: 1rem;
  font-weight: 400;
  border-radius: 5px;
`

export const ProductFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  //margin-top: 13px;
`

export const ProductListItemInner = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  width: 100%;

  position: relative;
  border-radius: 28px;
  transition: 0.5s ease;
  transition-property: transform;
  z-index: 5;
  background: #ffffff;
  border: solid 1px transparent;

  @media ${media.lg} {
    padding: 26px;
  }
`

export const ProductListItem = styled.li`
  display: flex;
  flex-direction: column;
  padding: 10px;

  height: auto;
  width: 100%;

  position: relative;
  border-radius: 28px;

  transition: 0.5s ease;
  transition-property: transform;
  z-index: 5;

  background: ${theme.colors.bgContent};
  border: solid 1px transparent;

  ${ProductProperties} {
    display: none;
  }

  @media ${media.lg} {
    padding: unset;
    height: 480px;

    &:hover {
      z-index: 10;

      ${ProductListItemInner} {
        border: 1px solid ${theme.colors.borderColor};
        transform: scale(1.05);
        position: absolute;
        min-height: 100%;
        left: 0;
        top: 0;
      }

      @media ${media.lg} {
        position: relative;

        ${ProductAbsolutable} {
          ${ProductProperties} {
            display: flex;
          }
        }

        ${ProductImage} img:not([data-back]) {
          display: none;
        }

        ${ProductImage} img[data-back] {
          display: flex;
        }
      }
    }

    ${ProductFooter} {
      display: flex;
    }
  }
`

export const ImageLoader = styled.svg<{$back?: boolean}>`
  position: absolute;
  align-self: center;
  text-align: center;

  display: flex !important;
  
  &[data-back] {
    display: none !important;
  }
  
  ${ProductListItem}:hover &[data-back]{
    @media ${media.lg} {
      display: flex !important;
    }
  }
`

export const ProductPrices = styled.div`
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
`

export const ProductPrice = styled.span`
  display: flex;
  align-items: center;

  line-height: 1.2;
  font-weight: 400;

  @media ${media.lg} {
    font-size: 1.25rem;
  }
`

export const ProductOldPrice = styled.span`
  display: flex;
  align-items: center;

  color: ${theme.colors.gray3};

  line-height: 1.2;

  text-decoration: line-through;
  font-weight: 400;

  @media ${media.lg} {
    font-size: 1rem;
  }
`

export const ProductName = styled.div`
  font-size: 1.25rem;
  font-weight: 450;
  line-height: 1.2;
  overflow: hidden;

  color: ${theme.colors.text};

  &:hover {
    color: ${theme.colors.text};
  }

  @media ${media.lg} {
    max-height: 72px;
  }
`

export const ProductActions = styled.div`
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const ProductBuyBtn = styled(Button)`
  font-size: 1.1875rem;
  font-weight: 450;
  align-items: center;
  display: flex;
  flex: 1;
    
  & > span {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }
  
  @media ${media.lg} {
    display: none;
  }
`
export const ProductBuyBtnWithVariant = styled(ProductBuyBtn)`
  display: none;

  @media ${media.lg} {
    display: flex;
    align-items: center;
  }
`

export const NameWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const ProductLink = styled(Link)`
  width: 100%;
  //flex: auto;

  & ${ProductName} {
    white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    //border-bottom: unset;
  }

  ${ProductListItem}:hover & {
    @media ${media.lg} {
      align-self: baseline;
      height: unset;
      //flex: unset;
    }
  }
`

export const AttributesModal = styled.div`
  @media ${media.lg} {
    display: none;
  }
`

export const MobileActions = styled.div`
  display: flex;

  @media ${media.lg} {
    display: none;
  }
`


export const InBasketLabel = styled.span`
  display: none;

  @media ${media.lg} {
    display: initial;
  }
`

export const InBasketIcon = styled.span`
  path {
    stroke: black;
  }
`

export const Badges = styled.div`
    display: none;
  
  @media ${media.lg} {
    display: flex;
  }
`